export const CHAVES_TEMA = [
  'page_bg', 'page_fg',
  'panel_bg', 'panel_fg',
  'app_header_bg', 'app_header_fg',
  'page_header_bg', 'page_header_fg',
  'modal_bg', 'modal_fg',
  'modal_header_bg', 'modal_header_fg',
  'card_bg', 'card_fg',
  'input_bg', 'input_fg', 'input_border',
  'popup_bg', 'popup_fg', 'popup_border',
  'grid_header_bg', 'grid_header_fg',
  'grid_subheader_bg', 'grid_subheader_fg',
  'grid_row_bg', 'grid_row_alt_bg', 'grid_row_fg', 'grid_row_hover_bg',
  'wa_sidebar_bg', 'wa_chat_header_bg', 'wa_chat_bg', 'wa_bubble_out_bg',
  'wa_text_fg', 'wa_subtext_fg',
  'tabs_bg', 'tabs_active_fg',
] as const;

export type ChaveTema = typeof CHAVES_TEMA[number];

export const TEMA_PADRAO: Record<ChaveTema, string> = {
  page_bg: '#f3f4f6',
  page_fg: '#1f2937',
  panel_bg: '#f9fafb',
  panel_fg: '#1f2937',
  app_header_bg: '#ffffff',
  app_header_fg: '#1f2937',
  page_header_bg: '#ffffff',
  page_header_fg: '#1f2937',
  modal_bg: '#ffffff',
  modal_fg: '#1f2937',
  modal_header_bg: '#ffffff',
  modal_header_fg: '#1f2937',
  card_bg: '#ffffff',
  card_fg: '#1f2937',
  input_bg: '#ffffff',
  input_fg: '#1f2937',
  input_border: '#d1d5db',
  popup_bg: '#ffffff',
  popup_fg: '#1f2937',
  popup_border: '#e5e7eb',
  grid_header_bg: '#1e3a8a',
  grid_header_fg: '#ffffff',
  grid_subheader_bg: '#1d4ed8',
  grid_subheader_fg: '#ffffff',
  grid_row_bg: '#ffffff',
  grid_row_alt_bg: '#f3f4f6',
  grid_row_fg: '#1f2937',
  grid_row_hover_bg: '#dbeafe',
  wa_sidebar_bg: '#1e1e1e',
  wa_chat_header_bg: '#252526',
  wa_chat_bg: '#b3b3b3',
  wa_bubble_out_bg: '#fff176',
  wa_text_fg: '#e5e7eb',
  wa_subtext_fg: '#9ca3af',
  tabs_bg: '#f3f4f6',
  tabs_active_fg: '#2563eb',
};

const CHAVE_PARA_VAR: Record<ChaveTema, string> = {
  page_bg: '--page-bg',
  page_fg: '--page-fg',
  panel_bg: '--panel-bg',
  panel_fg: '--panel-fg',
  app_header_bg: '--app-header-bg',
  app_header_fg: '--app-header-fg',
  page_header_bg: '--page-header-bg',
  page_header_fg: '--page-header-fg',
  modal_bg: '--modal-bg',
  modal_fg: '--modal-fg',
  modal_header_bg: '--modal-header-bg',
  modal_header_fg: '--modal-header-fg',
  card_bg: '--card-bg',
  card_fg: '--card-fg',
  input_bg: '--input-bg',
  input_fg: '--input-fg',
  input_border: '--input-border',
  popup_bg: '--popup-bg',
  popup_fg: '--popup-fg',
  popup_border: '--popup-border',
  grid_header_bg: '--grid-header-bg',
  grid_header_fg: '--grid-header-fg',
  grid_subheader_bg: '--grid-subheader-bg',
  grid_subheader_fg: '--grid-subheader-fg',
  grid_row_bg: '--grid-row-bg',
  grid_row_alt_bg: '--grid-row-alt-bg',
  grid_row_fg: '--grid-row-fg',
  grid_row_hover_bg: '--grid-row-hover-bg',
  wa_sidebar_bg: '--wa-sidebar-bg',
  wa_chat_header_bg: '--wa-chat-header-bg',
  wa_chat_bg: '--wa-chat-bg',
  wa_bubble_out_bg: '--wa-bubble-out-bg',
  wa_text_fg: '--wa-text-fg',
  wa_subtext_fg: '--wa-subtext-fg',
  tabs_bg: '--tabs-bg',
  tabs_active_fg: '--tabs-active-fg',
};

// Campos *_fg de cabecalho que suportam gradient via background-clip: text.
// Quando o valor e gradient, setamos DUAS vars: a cor solida (pra fallback /
// icones) e o gradient string (pro background-clip text).
const FG_COM_GRADIENT = new Set<ChaveTema>([
  'app_header_fg',
  'page_header_fg',
  'modal_header_fg',
]);

const REGEX_GRADIENT_C1 =
  /^linear-gradient\(\s*\d{1,3}deg\s*,\s*(#[0-9a-fA-F]{6})\s+0%\s*,\s*#[0-9a-fA-F]{6}\s+100%\s*\)$/;

export function aplicarTemaNoRoot(tema: Partial<Record<ChaveTema, string>>): void {
  const root = document.documentElement;
  for (const chave of CHAVES_TEMA) {
    const valor = tema[chave] ?? TEMA_PADRAO[chave];
    const cssVar = CHAVE_PARA_VAR[chave];
    if (FG_COM_GRADIENT.has(chave)) {
      const m = REGEX_GRADIENT_C1.exec(valor);
      if (m) {
        // gradient: var solida = primeira cor (pra icones SVG via currentColor);
        // var -grad = gradient full (pra background-clip text)
        root.style.setProperty(cssVar, m[1]!);
        root.style.setProperty(cssVar + '-grad', valor);
      } else {
        // solido: ambos iguais — clip-text fica visualmente igual a color normal
        root.style.setProperty(cssVar, valor);
        root.style.setProperty(cssVar + '-grad', valor);
      }
    } else {
      root.style.setProperty(cssVar, valor);
    }
  }
}
